import React from 'react';
import { IoShareSocialOutline } from '@react-icons/all-files/io5/IoShareSocialOutline';

import { decorateComponent } from '../../../documentComponents';
import { ImageMapShare } from './ImageMapShare';
import { ImageMapShareInspector } from './ImageMapShare.Inspector';

export default decorateComponent(ImageMapShare, 'block', {
  id: 'imageMapShare',
  label: '이미지 영역 공유하기',
  disabledMove: true,
  allowedParent: ['image'],
  allowedChildren: [],
  disallowedAncestors: [
    'a',
    'coupon',
    'tabButton',
  ],
  defaultProps: {
    platform: 'kakaotalk',
    style: {
      top: '25%',
      left: '25%',
      width: '50%',
      height: '50%',
    },
  },
  renderIcon: () => <IoShareSocialOutline />,
  renderInspector: ImageMapShareInspector,
});
